var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const Success1 = (_a) => {
    var { color = '#89C900', fill = 'none', width = 100, height = 100 } = _a, props = __rest(_a, ["color", "fill", "width", "height"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: `0 0 ${width} ${height}`, fill: fill, xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "100", height: "100", rx: "50", fill: color, fillOpacity: "0.08" }),
        React.createElement("path", { d: "M50.0007 76.6667C64.6673 76.6667 76.6673 64.6667 76.6673 50C76.6673 35.3334 64.6673 23.3334 50.0007 23.3334C35.334 23.3334 23.334 35.3334 23.334 50C23.334 64.6667 35.334 76.6667 50.0007 76.6667Z", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M38.666 50L46.2127 57.5467L61.3327 42.4534", stroke: color, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
export default Success1;
